import { render } from "./Courses.vue?vue&type=template&id=e16157cc"
import script from "./Courses.vue?vue&type=script&lang=js"
export * from "./Courses.vue?vue&type=script&lang=js"
script.render = render

export default script